import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container']

  connect () {
    this.scrollElement = document.querySelector('.scroll-container')
    if (!this.scrollElement) {
      return
    }

    this.lastScrollY = this.scrollElement.scrollTop
    this.onScroll = this.handleScroll.bind(this)
    this.scrollElement.addEventListener('scroll', this.onScroll)
  }

  disconnect () {
    if (this.scrollElement) {
      this.scrollElement.removeEventListener('scroll', this.onScroll)
    }
  }

  handleScroll () {
    const currentScrollY = this.scrollElement.scrollTop

    if (!this.containerTarget) return

    if (currentScrollY > this.lastScrollY + 20) {
      this.containerTarget.classList.add('opacity-0', 'pointer-events-none')
    } else if (currentScrollY < this.lastScrollY - 20) {
      this.containerTarget.classList.remove('opacity-0', 'pointer-events-none')
    }

    this.lastScrollY = currentScrollY
  }
}
